import { ResultObjectType } from '@cbgms/api'
import { ReactFragment } from 'react'

export enum ESearchFilterValue {
  AllGMS = 'all_gms',
  AllPortal = 'all_portal',
  Vehicles = 'vehicles',
  Account = 'account',
  Parts = 'parts',
  Invoice = 'invoice',
  Quotations = 'quotations',
  Order = 'order',
  WorkOrder = 'workorder',
  Tyres = 'tyres'
}

export interface IMenuItem {
  value: ESearchFilterValue
  translateKey: string
  icon: ReactFragment
}

export const allFiltersShared = [
  ResultObjectType.Account,
  ResultObjectType.DatabaseVehicle,
  ResultObjectType.GenericVehicle,
  ResultObjectType.WorkorderQuotation,
  ResultObjectType.VehicleSalesQuotation,
  ResultObjectType.Order,
  ResultObjectType.WorkOrder,
  ResultObjectType.WorkOrderArchive
]
export const allFiltersPortal = [...allFiltersShared, ResultObjectType.Parts, ResultObjectType.TyreSize]
export const allFiltersGMS = [...allFiltersShared, ResultObjectType.Invoice]

export const mapValueToFilterArray = (value: ESearchFilterValue): ResultObjectType[] => {
  switch (value) {
    case ESearchFilterValue.Vehicles:
      return [ResultObjectType.DatabaseVehicle, ResultObjectType.GenericVehicle]
    case ESearchFilterValue.Account:
      return [ResultObjectType.Account]
    case ESearchFilterValue.Parts:
      return [ResultObjectType.Parts]
    case ESearchFilterValue.Invoice:
      return [ResultObjectType.Invoice]
    case ESearchFilterValue.Quotations:
      return [ResultObjectType.WorkorderQuotation, ResultObjectType.VehicleSalesQuotation]
    case ESearchFilterValue.Order:
      return [ResultObjectType.Order]
    case ESearchFilterValue.WorkOrder:
      return [ResultObjectType.WorkOrder, ResultObjectType.WorkOrderArchive]
    case ESearchFilterValue.Tyres:
      return [ResultObjectType.TyreSize]
    case ESearchFilterValue.AllPortal:
      return allFiltersPortal
    case ESearchFilterValue.AllGMS:
    default:
      return allFiltersGMS
  }
}
